module.exports = __webpack_public_path__ + "static/media/bags-p-img1-1.1429d9e3.jpg";